module.exports = "/_next/static/images/dot grid-b3abe3151512dd01dd154d898ef17d3c.svg";